import { Route } from "react-router-dom";
import { ProtectedRoute } from "../../routers/protected-route";
import { RequestWrapper } from "../../routers/request-wrapper";
import { Site, Sites, UpdateSite } from "./pages";

export const SitesRouter = [
  <Route
    path="/sites"
    element={
      <ProtectedRoute roles={["Any"]}>
        <RequestWrapper component={Sites} />
      </ProtectedRoute>
    }
  />,
  <Route path="/site">
    <Route
      path=":id"
      element={
        <ProtectedRoute roles={["Any"]}>
          <Site />
        </ProtectedRoute>
      }
    />
    ,
    <Route
      path=":id/update"
      element={
        <ProtectedRoute roles={["Any"]}>
          <UpdateSite />
        </ProtectedRoute>
      }
    />
  </Route>,
];
export const AdminSitesRouter = [
  <Route
    path="/sites"
    element={
      <ProtectedRoute roles={["Any"]}>
        <RequestWrapper component={Sites} />
      </ProtectedRoute>
    }
  />,
  <Route path="/site">
    <Route
      path=":id"
      element={
        <ProtectedRoute roles={["Any"]}>
          <Site />
        </ProtectedRoute>
      }
    />
    ,
    <Route
      path=":id/update"
      element={
        <ProtectedRoute roles={["Any"]}>
          <UpdateSite />
        </ProtectedRoute>
      }
    />
  </Route>,
];

export const ClientSitesRouter = [
  <Route
    path="/sites"
    element={
      <ProtectedRoute roles={["Any"]}>
        <RequestWrapper component={Sites} />
      </ProtectedRoute>
    }
  />,
  <Route path="/site">
    <Route
      path=":id"
      element={
        <ProtectedRoute roles={["Any"]}>
          <Site />
        </ProtectedRoute>
      }
    />
  </Route>,
];
